import classes from './Grid.module.scss';
import { Card } from "../Card";
import { motion } from 'framer-motion';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { NAME_SOUND_ACTIVE, TYPE_QUESTIONS, useGameSounds } from '@educaplay/core';
import { CARD_TYPE } from '../../utils/constants';
import { RELACIONAR_SOUNDS } from '../../../../../games/RELACIONAR/src/utils/constants';

const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const Grid = (props) => {
    const { cards, onAnswer } = props;
    const questions = useSelector(state => state.game.questions);
    const currentIndex = useSelector(state => state.game.currentIndex);
    const correctAnswers = questions[currentIndex].correctIdAnswers;
    const [showFeedback, setShowFeedback] = useState(false); 
    const [selectedCards, setSelectedCards] = useState([]);
    const [incorrectCards, setIncorrectCards] = useState([]);
    const [correctCards, setCorrectCards] = useState([]);
    const [pendingCards, setPendingCards] = useState([]);
    const gameSound = useGameSounds();
    const [currentAudioPlaying, setCurrentAudioPlaying] = useState(null);

    const penalty = useSelector(state => state.game.liveActived);

    const getSelectedCards = (cardId) => {
        if(!selectedCards.includes(cardId)) return [...selectedCards, cardId];
        gameSound.play('relacionar-deselect');
        return selectedCards.filter(item => item !== cardId);
    }

    const reset = () => {
        gameSound.play('relacionar-deselectGroup');
        setSelectedCards([]);
        setShowFeedback(false);
        setIncorrectCards([]);
        setPendingCards([]);
        setCorrectCards([]);
    }

    const hasError = (currentSelection) => {
        return currentSelection.some((cardId) => !correctAnswers.includes(cardId))
    }

    const isComplete = (currentSelection) => { 
        return correctAnswers.every((cardId) => currentSelection.includes(cardId))
    }

    const checkSelectedCards = async (currentSelection) => {
        setPendingCards([]);

        if(currentSelection.length <= 1) {
            gameSound.play(NAME_SOUND_ACTIVE);
            if(!penalty) {
                setPendingCards([...currentSelection]);
                return;
            }
        }

        if(!penalty && hasError(currentSelection)) {
            onAnswer({
                answer: {
                    type: TYPE_QUESTIONS.Selection,
                    answer: currentSelection
                },
                isCorrect: !hasError(currentSelection),
                playErrorSound: false
            })

            reset()
            return;
        }


        if((hasError(currentSelection) || isComplete(currentSelection))) {
            gameSound.play(NAME_SOUND_ACTIVE);
            setShowFeedback(true);

            const currentIncorrectCards = currentSelection.filter((cardId) => !correctAnswers.includes(cardId));
            setIncorrectCards(currentIncorrectCards);

            if(isComplete(currentSelection)) {
                gameSound.play(RELACIONAR_SOUNDS.CORRECT);
                setCorrectCards(currentSelection);
            }

            await wait(1000);

            onAnswer({
                answer: {
                    type: TYPE_QUESTIONS.Selection,
                    answer: currentSelection
                },
                isCorrect: !hasError(currentSelection)
            })

            await wait(300);

            reset()
            return;
        }
        gameSound.play('relacionar-selectGroup');
    }

    const handleClick = (card) => {
        if([CARD_TYPE.CardAudio, CARD_TYPE.CardTextAudio].includes(card.cardType)) {
            setCurrentAudioPlaying(card.id);
        }
        const newSelectedCards = getSelectedCards(card.id);
        setSelectedCards(newSelectedCards);
        checkSelectedCards(newSelectedCards);
    }

    return (
        <div className={clsx(classes.board, showFeedback && classes.disabled)}>
            {cards.map((card, index) => {
                return (
                    <motion.div
                        key={card.id}
                        className={classes.cardWrapper}
                        layoutId={card.id}
                        initial={{rotate: -45}}
                        animate={{rotate: 0}}
                        transition={{ type: "spring", bounce: 0.1, delay: .03*index }} >
                            <Card
                                hasError={incorrectCards.includes(card.id)}
                                isPressed={selectedCards.includes(card.id)}
                                isPending={pendingCards.includes(card.id)}
                                hasSuccess={correctCards.includes(card.id)}
                                className={clsx(selectedCards.includes(card.id) && classes.selected)}
                                onClick={() => handleClick(card)}
                                cardData={card}
                                autoplay={currentAudioPlaying === card.id}
                            />
                    </motion.div>
                )
            })}
        </div>
    )
}

export default Grid;